import { defineSlotRecipe } from '@chakra-ui/react';

export const autocompleteSlotRecipe = defineSlotRecipe({
    slots: ['list', 'noResults', 'wrapper'],
    base: {
        wrapper: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
        },
        list: {
            bgColor: 'white',
            w: {
                base: '100%',
                md: '20rem',
                lg: '25rem',
            },
            boxShadow: 'md',
            borderRadius: 'md',
            zIndex: 'popover',
            overflow: 'auto',
        },
        noResults: {
            fontSize: 'sm',
            color: 'gray.700',
            display: 'block',
            p: 3,
        },
    },
});
